import { coreService } from "../../../../services/coreService";
import { buildQuery } from "../../../../lib/network";

export default function getReInspectionPreviousInspections(headers: any, id: number) {
  return () => {
    return buildQuery(coreService.inspectionsPreviousInspectionsDetail(id, { headers }), (response) => {
      return response.data;
    });
  };
}
